// Docs: search (a dialog over /docs/search.json, opened by the button, "/" or Cmd/Ctrl+K) and the
// "On this page" highlight. No library: the index is small, so matching is a word-prefix search that
// needs every term to match and ranks title over heading over text.

const dialog = document.querySelector('[data-docs-search]');

if (dialog) {
    const input = dialog.querySelector('[data-docs-search-input]');
    const list = dialog.querySelector('[data-docs-search-results]');
    const empty = dialog.querySelector('[data-docs-search-empty]');
    let records = null;
    let active = -1;

    const isMac = /Mac|iPhone|iPad/.test(navigator.platform);
    document.querySelectorAll('[data-docs-kbd]').forEach((k) => { k.textContent = isMac ? '⌘K' : 'Ctrl K'; });

    const load = () => records
        ? Promise.resolve(records)
        : fetch(dialog.dataset.index, { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .then((data) => (records = data.map((r) => ({ ...r, hay: [r.title, r.heading || '', r.text].map((s) => s.toLowerCase()) }))))
            .catch(() => (records = []));

    const open = () => {
        if (!dialog.open) dialog.showModal();
        input.focus();
        input.select();
        load().then(() => render(input.value));
    };
    const close = () => dialog.close();

    const escape = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const highlight = (text, terms) => {
        let html = escape(text);
        terms.forEach((t) => {
            html = html.replace(new RegExp('(^|[^\\w])(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi'), '$1<mark>$2</mark>');
        });
        return html;
    };
    const snippet = (text, terms) => {
        const lower = text.toLowerCase();
        const at = Math.max(0, Math.min(...terms.map((t) => { const i = lower.indexOf(t); return i < 0 ? Infinity : i; })) - 40);
        const cut = Number.isFinite(at) ? at : 0;
        return (cut > 0 ? '…' : '') + text.slice(cut, cut + 160) + (text.length > cut + 160 ? '…' : '');
    };

    const render = (query) => {
        const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
        list.innerHTML = '';
        active = -1;
        empty.hidden = true;
        if (!terms.length || !records) return;

        const startsWord = (hay, t) => hay.startsWith(t) || hay.includes(' ' + t) || hay.includes('(' + t);
        const results = records
            .map((r) => {
                let score = 0;
                for (const t of terms) {
                    const [title, heading, text] = r.hay;
                    if (startsWord(title, t)) score += 6;
                    else if (startsWord(heading, t)) score += 3;
                    else if (startsWord(text, t)) score += 1;
                    else return null;
                }
                return { r, score: score + (r.heading ? 0 : 0.5) };
            })
            .filter(Boolean)
            .sort((a, b) => b.score - a.score)
            .slice(0, 12);

        if (!results.length) { empty.hidden = false; return; }

        let lastSection = null;
        results.forEach(({ r }) => {
            if (r.section !== lastSection) {
                const g = document.createElement('li');
                g.className = 'dc-search__group';
                g.setAttribute('role', 'presentation');
                g.textContent = r.section;
                list.appendChild(g);
                lastSection = r.section;
            }
            const li = document.createElement('li');
            li.className = 'dc-search__item';
            li.setAttribute('role', 'option');
            li.innerHTML = '<a href="' + escape(r.url) + '"><b>' + highlight(r.heading ? r.title + ': ' + r.heading : r.title, terms) + '</b><span>' + highlight(snippet(r.text, terms), terms) + '</span></a>';
            list.appendChild(li);
        });
    };

    const items = () => [...list.querySelectorAll('.dc-search__item')];
    const move = (step) => {
        const all = items();
        if (!all.length) return;
        active = (active + step + all.length) % all.length;
        all.forEach((el, i) => el.classList.toggle('is-active', i === active));
        all[active].scrollIntoView({ block: 'nearest' });
    };

    document.querySelectorAll('[data-docs-search-open]').forEach((b) => b.addEventListener('click', open));
    dialog.querySelector('[data-docs-search-close]').addEventListener('click', close);
    dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
    input.addEventListener('input', () => render(input.value));
    input.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
        if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
        if (e.key === 'Enter') {
            const target = items()[active >= 0 ? active : 0];
            if (target) { e.preventDefault(); window.location.href = target.querySelector('a').href; }
        }
    });
    list.addEventListener('click', (e) => { if (e.target.closest('a')) close(); });

    document.addEventListener('keydown', (e) => {
        const typing = /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName) || document.activeElement?.isContentEditable;
        if ((e.key === 'k' && (e.metaKey || e.ctrlKey)) || (e.key === '/' && !typing)) {
            e.preventDefault();
            open();
        }
    });
}

// "On this page": highlight the heading you're reading.
const toc = document.querySelector('[data-docs-toc]');
if (toc && 'IntersectionObserver' in window) {
    const links = new Map([...toc.querySelectorAll('a')].map((a) => [decodeURIComponent(a.hash.slice(1)), a]));
    const headings = [...links.keys()].map((id) => document.getElementById(id)).filter(Boolean);
    const visible = new Set();
    const update = () => {
        const current = headings.find((h) => visible.has(h)) || headings.filter((h) => h.getBoundingClientRect().top < 120).pop();
        links.forEach((a) => a.classList.remove('is-active'));
        if (current) links.get(current.id)?.classList.add('is-active');
    };
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
        update();
    }, { rootMargin: '-96px 0px -60% 0px' });
    headings.forEach((h) => observer.observe(h));
}
